import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import employees from 'store/app/entities/employees/action';

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  actions: {
    employees: bindActionCreators(employees, dispatch),
  },
});

export default connect(mapStateToProps, mapDispatchToProps);
